import {
    Component, EventEmitter,
    Input,
    OnInit, Output
} from "@angular/core";

import {Observable} from "rxjs";
import {FormGroup} from "@angular/forms";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
    selector: 'app-validity-check',
    templateUrl: './validity-check.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class ValidityCheckComponent implements OnInit{
    @Input() providerActivities: Observable<any[]>;
    @Input() form: FormGroup;
    @Input() theme = 'dark'
    @Input() mode = 'new';
    @Input() data: any;
    @Input() uploading = false;
    @Output() result = new EventEmitter<any>;

    activities: any[] = [];
    activity: any = {};
    summary: string = null;

    existingActivityId = -1;

    constructor(private snackBar: MatSnackBar) {
    }
    ngOnInit(): void {
        this.providerActivities.subscribe(r => {
            if(this.existingActivityId == this.activity.id) {
                this.showExistingData();
            } else {
                for(let i = 0; i < r.length; i++) {
                    r[i].completionQuestionAnswer = null;
                    if(r[i].conditions && r[i].conditions.length > 0) {
                        for(let j = 0; j < r[i].conditions.length; j++) {
                            r[i].conditions[j].answer = null;
                            r[i].conditions[j].isValid = false;
                        }
                    }
                }
                this.activities = [...r];

                let activity = this.activities.find(a => a.id == this.form.controls.activity.value);
                if(activity) {
                    this.activity = activity;
                    this.existingActivityId = this.activity.id;
                    this.showExistingData();
                }
            }

        })

        this.form.controls.activity.valueChanges.subscribe(r => {
            if(this.activities.length == 0) return;
            let activity = this.activities.find(a => a.id == r);
            if(activity) {
                this.activity = activity;
                if(this.existingActivityId == this.activity.id) {
                    this.showExistingData();
                } else {
                    this.existingActivityId = this.activity.id;
                }
            }
        })
    }

    showExistingData() {
        if(this.data) {
            let d = JSON.parse(this.data);
            console.log(d);
            if(this.mode == 'edit') {
                for(let j = 0; j < this.activity.conditions.length; j++) {
                    this.activity.conditions[j].answer = d.activity.conditions[j].answer;
                }

                this.activity.completionQuestionAnswer = d.activity.completionQuestionAnswer;

                this.getSummary();
            }
        }

    }

    getSummary() {
        this.summary = null;
        let countValidAnswer = 0;
        let countAnswer = 0;

        for(let j = 0; j < this.activity.conditions.length; j++) {
                countAnswer++;
                if(this.activity.conditions[j].answer) {
                    if(this.activity.conditions[j].conditionType == 'BOOLEAN') {

                        if(this.activity.conditions[j].valueIfValid == this.activity.conditions[j].answer) {
                            countValidAnswer++;
                            this.activity.conditions[j].isValid = true;
                        }
                    } else {

                        switch (this.activity.conditions[j].integerOperator.toUpperCase()) {
                            case 'EQ': {
                                if(Number(this.activity.conditions[j].answer) == Number(this.activity.conditions[j].valueIfValid)) {
                                    countValidAnswer++;
                                    this.activity.conditions[j].isValid = true;
                                }
                                break;
                            }
                            case 'LT': {
                                if(Number(this.activity.conditions[j].answer) < Number(this.activity.conditions[j].valueIfValid)) {
                                    countValidAnswer++;
                                    this.activity.conditions[j].isValid = true;
                                }
                                break;
                            }
                            case 'LTE': {
                                if(Number(this.activity.conditions[j].answer) <= Number(this.activity.conditions[j].valueIfValid)) {
                                    countValidAnswer++;
                                    this.activity.conditions[j].isValid = true;
                                }
                                break;
                            }
                            case 'GT': {
                                if(Number(this.activity.conditions[j].answer) > Number(this.activity.conditions[j].valueIfValid)) {
                                    countValidAnswer++;
                                    this.activity.conditions[j].isValid = true;
                                }
                                break;
                            }
                            case 'GTE': {
                                if(Number(this.activity.conditions[j].answer) >= Number(this.activity.conditions[j].valueIfValid)) {
                                    countValidAnswer++;
                                    this.activity.conditions[j].isValid = true;
                                }
                                break;
                            }
                        }
                    }

                } else {
                    this.snackBar.open('Please answer activity condition', '', {duration: 3000, verticalPosition: 'top', horizontalPosition: 'right'})
                    return;
                }
            }

        let score = this.activity.ceuValue * this.activity.completionQuestionAnswer;

        if(!this.activity.completionQuestionAnswer) {
            this.snackBar.open('Please answer activity completion question', '', {duration: 3000, verticalPosition: 'top', horizontalPosition: 'right'})
            return;
        }

        if(countValidAnswer == countAnswer) {

            this.summary = `Based on a quick validity check, your activity appears to be valid with an estimated value of: ${score} CE.`;
        } else {
            this.summary = `Based on a quick validity check, your activity appears to be NOT valid with an estimated value of: ${score} CE.`;
        }

        this.result.emit({
            summary: this.summary,
            countAnswer: countAnswer,
            countValidAnswer: countValidAnswer,
            activity: this.activity,
            score: score,
            providerActivityId: this.form.controls.activity.value,
        })
    }
}
